import styled from "styled-components";

export const StepContainer = styled.div`
display: flex;
`;

export const RadioWrapper = styled.div`

  width: 465px;
  border: 1px solid var(--color-brand-pink-primary);
  background: var(--color-workspace-bg-page-area);
  border-radius: 10px;
  margin: 5px;
  display: flex;
  ${props => props.checked ? 'border: 1px solid var(--color-brand-pink-primary);' : 'border: 1px solid #E7E7E7;'};
  cursor: pointer;

`;

export const InputRadio = styled.input`

  background: var(--color-workspace-bg-page-area);
  border: 1px solid var(--color-createenv-stepper-input-radio-btn-bg);
  border-radius: 10px;
  align-items: flex-start;
  cursor: pointer;
  accent-color: var(--color-brand-pink-primary);
`;

export const ScenarioLabel = styled.label`
  padding: 10px;
  cursor: pointer;
`;

export const ScenarioSpanLabel = styled.span`
  ${props => props.checked && 'color: var(--color-brand-pink-primary);'};
`

export const Button = styled.button`

  width: 75px;
  height: 36px;
  background: var(--color-workspace-bg-page-area);
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: var(--color-table-even);
    color: var(--color-brand-pink-primary);
  }

  &.next {
    background: var(--color-brand-pink-primary);
    background: var(--color-brand-pink-primary);
    color: var(--color-workspace-bg-page-area);
    border-radius: 2px;
    margin-right: 17px;

    ${props => props.disabled ? 'pointer-events: none;' : ''}
    ${props => props.disabled ? 'background: var(--color-brand-pink-primary) ;' : ''}
    ${props => props.disabled ? 'background: #f1d8df;' : ''}
    &:hover {
      background: var(--color-createenv-stepper-next-btn-bg-hover);
    }
  }
`;

export const P = styled.p`
  font-size: 12px;
  color: #707070
`;